export const weightInputs = [
  {
    name: "weight",
    value: 2,
    label: "0,01 - 2",
  },
  {
    name: "weight",
    value: 5,
    label: "2,01 - 5",
  },
  {
    name: "weight",
    value: 10,
    label: "5,01 - 10",
  },
  {
    name: "weight",
    value: 20,
    label: "10,01 - 20",
  },
  {
    name: "weight",
    value: 30,
    label: "20,01 - 30",
  },
  {
    name: "weight",
    value: 50,
    label: "30,01 - 50",
  },
  {
    name: "weight",
    value: 70,
    label: "50,01 - 70",
  },
  {
    name: "weight",
    value: 100,
    label: "70,01 - 100",
  },
];

export const freightInputs = [
  {
    name: "freight",
    value: 1,
    label: "included",
    explain: "includesTax",
  },
  {
    name: "freight",
    value: 2,
    label: "includedWithoutSendcloud",
    explain: "youPayFreight",
  },
  {
    name: "freight",
    value: 3,
    label: "paid",
    explain: "paidFreight",
  },
  {
    name: "freight",
    value: 4,
    label: "paidOrWithdrawn",
    explain: "paidOrWithdrawnExplain",
  },
];

export const listTypeProduct = [
  {
    image: "Comércio_e_escritório_uobmb6",
    title: "product",
    type: 1,
  },
  {
    image: "Serviços_vlt0oa",
    title: "service",
    type: 2,
  },
  {
    image: "download-solid_t4lktk",
    title: "downloadable",
    type: 3,
  },
];
